import { Button, DialogActions } from '@mui/material';
import React from 'react';

const CompleteDialogActions = ({ disabled, loading, onCancel, onConfirm }) => {
	return (
		<DialogActions>
			<Button
				onClick={onCancel}
				color='primary'
				// disabled={loading}
			>
				Cancel
			</Button>
			<Button
				loading={loading}
				color='primary'
				onClick={onConfirm}
				variant='contained'
				disabled={disabled}
			>
				Complete
			</Button>
		</DialogActions>
	);
};
export default CompleteDialogActions;
